<template>
    <div class="weeduc-admin-page__toolbar-field-row">
        <v-text-field
            :model-value="filters.search"
            :label="labels.search"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            append-inner-icon="mdi-magnify"
            class="inputd weeduc-admin-v-field collab-filters__search"
            @update:model-value="patch('search', $event)"
        />
        <v-select
            v-if="showSector"
            :model-value="filters.sectorId"
            :items="sectorSelectOptions"
            item-title="text"
            item-value="value"
            :label="labels.sector"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="inputd weeduc-admin-v-field"
            @update:model-value="patch('sectorId', $event)"
        />
        <v-select
            v-if="showRole"
            :model-value="filters.roleId"
            :items="roleSelectOptions"
            item-title="text"
            item-value="value"
            :label="labels.role"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="inputd weeduc-admin-v-field"
            @update:model-value="patch('roleId', $event)"
        />
        <v-select
            v-if="showStatus"
            :model-value="filters.status"
            :items="statusOptions"
            item-title="text"
            item-value="value"
            :label="labels.status"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="inputd weeduc-admin-v-field"
            @update:model-value="patch('status', $event)"
        />
        <v-select
            v-if="showResponsible"
            :model-value="filters.isResponsible"
            :items="responsibleOptions"
            item-title="text"
            item-value="value"
            :label="labels.responsible"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="inputd weeduc-admin-v-field"
            @update:model-value="patch('isResponsible', $event)"
        />
        <v-select
            v-if="showType"
            :model-value="filters.type"
            :items="typeOptions"
            item-title="text"
            item-value="value"
            :label="labels.gestor"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="inputd weeduc-admin-v-field"
            @update:model-value="patch('type', $event)"
        />
    </div>
</template>

<script>
import { CORPORATE_USER_TYPE } from '@/utils/corporate/users';

export default {
    name: 'CollaboratorFilters',
    props: {
        filters: {
            type: Object,
            required: true,
        },
        labels: Object,
        sectorOptions: { type: Array, default: () => [] },
        roleOptions: { type: Array, default: () => [] },
        showType: { type: Boolean, default: true },
        showSector: { type: Boolean, default: true },
        showRole: { type: Boolean, default: true },
        showResponsible: { type: Boolean, default: true },
        showStatus: { type: Boolean, default: true },
        includeAll: { type: Boolean, default: true },
    },
    emits: ['update:filters'],
    computed: {
        statusOptions() {
            const items = [
                { text: this.labels.active, value: 'active' },
                { text: this.labels.inactive, value: 'inactive' },
            ];
            return this.withAllOption(items);
        },
        sectorSelectOptions() {
            return this.withoutEmptyAll(this.sectorOptions);
        },
        roleSelectOptions() {
            return this.withoutEmptyAll(this.roleOptions);
        },
        typeOptions() {
            return this.withAllOption([
                { text: this.labels.gestor, value: CORPORATE_USER_TYPE.GESTOR },
                { text: this.labels.collaboratorFilter, value: CORPORATE_USER_TYPE.COLABORADOR },
            ]);
        },
        responsibleOptions() {
            return this.withAllOption([
                { text: this.labels.yes, value: 'yes' },
                { text: this.labels.no, value: 'no' },
            ]);
        },
    },
    methods: {
        patch(key, value) {
            this.$emit('update:filters', { ...this.filters, [key]: value });
        },
        withAllOption(items) {
            if (!this.includeAll) return items;
            return [{ text: this.labels.all, value: null }, ...items];
        },
        withoutEmptyAll(items) {
            if (this.includeAll) return items;
            return (items || []).filter((item) => item.value != null && item.value !== '');
        },
    },
};
</script>

<style scoped>
.collab-filters__search {
    flex: 1.6 1 220px;
}
</style>
